import type { FC } from "react";
import { PiCaretDownBold } from "react-icons/pi";
import Icon from "../icon/icon";
import * as CSS from "./select.styles";
import type { SelectProps } from "./select.types";

const Select: FC<SelectProps> = ({
	id,
	value,
	onChange,
	options,
	groups,
	placeholder,
	disabled = false,
}) => {
	return (
		<CSS.Wrapper>
			<CSS.Select
				id={id}
				value={value}
				disabled={disabled}
				onChange={(e) => onChange(e.target.value)}
			>
				{placeholder && <option value="">{placeholder}</option>}
				{options?.map((option) => (
					<option key={option.value} value={option.value}>
						{option.label}
					</option>
				))}
				{groups?.map((group) => (
					<optgroup key={group.label} label={group.label}>
						{group.options.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
						))}
					</optgroup>
				))}
			</CSS.Select>
			<CSS.Caret>
				<Icon icon={PiCaretDownBold} size={16} />
			</CSS.Caret>
		</CSS.Wrapper>
	);
};

export default Select;
